export default "__VITE_ASSET__Gfaq3Wrk__"